module.exports = __webpack_public_path__ + "img/gayw.fd82d37a.svg";